import { useCallback, useEffect, useState } from "react";
import { getRecentlyFocusedMap, markFocused } from "@/lib/recentlyFocused";

// Map of taskId → timestamp of last completed Pomodoro focus session.
// Drives the "Recently focused" pill in task rows. Backed by localStorage
// with a 24h TTL — purely a soft UI cue, not a server stat.
export function useRecentFocus() {
    const [recentFocusMap, setRecentFocusMap] = useState(() => getRecentlyFocusedMap());

    useEffect(() => {
        // Prune expired entries roughly every 10 minutes while the tab is open.
        const id = setInterval(() => setRecentFocusMap(getRecentlyFocusedMap()), 10 * 60 * 1000);
        return () => clearInterval(id);
    }, []);

    const handleFocusComplete = useCallback((taskId) => {
        if (!taskId) return;
        setRecentFocusMap(markFocused(taskId));
    }, []);

    return { recentFocusMap, handleFocusComplete };
}
